// extracted by mini-css-extract-plugin
module.exports = {"main-yellow":"#fcd406","heading":"ProgressTop-module__heading___2o8Rg","subheading":"ProgressTop-module__subheading___ALiWb","button":"ProgressTop-module__button___1zRmz"};